import intellegenceService from "../shared/services/intellegenceService";
import getDates from "../shared/services/date.service";
import { setLogout } from "./authActions";

const REQUEST_MAP_DRAIN_POSITIONS = "REQUEST_MAP_DRAIN_POSITIONS";
const RESPONSE_MAP_DRAIN_POSITIONS = "RESPONSE_MAP_DRAIN_POSITIONS";
const REQUEST_MAP_DRAIN_POSITIONS_FAILURE = "REQUEST_MAP_DRAIN_POSITIONS_FAILURE";
const CLEAR_MAP_DRAIN_POSITIONS = "CLEAR_MAP_DRAIN_POSITIONS";

const requestMapDrainPositionsAction = () => {
  return {
    type: REQUEST_MAP_DRAIN_POSITIONS,
  };
};

const responseMapDrainPositionsAction = (data) => {
  return {
    type: RESPONSE_MAP_DRAIN_POSITIONS,
    payload: data,
  };
};

const requestMapDrainPositionsFailureAction = (errors) => {
  return {
    type: REQUEST_MAP_DRAIN_POSITIONS_FAILURE,
    errors,
  };
};

const getMapDrainPositions = (options) => {
  const startDate = getDates.fixISOStringDateToPost(options.startDate);
  const endDate = getDates.fixISOStringDateToPost(options.endDate);

  return (dispatch) => {
    dispatch(requestMapDrainPositionsAction());

    intellegenceService
      .getDrains(options.carId, {
        startDate,
        endDate,
        timeZone: (new Date().getTimezoneOffset() / 60) * -1,
      })
      .then((result) => {
        dispatch(responseMapDrainPositionsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestMapDrainPositionsFailureAction(error.response));

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const clearMapDrainPositionsAction = () => {
  return {
    type: CLEAR_MAP_DRAIN_POSITIONS,
  };
};

export {
  REQUEST_MAP_DRAIN_POSITIONS,
  RESPONSE_MAP_DRAIN_POSITIONS,
  REQUEST_MAP_DRAIN_POSITIONS_FAILURE,
  CLEAR_MAP_DRAIN_POSITIONS,
  requestMapDrainPositionsAction,
  responseMapDrainPositionsAction,
  requestMapDrainPositionsFailureAction,
  getMapDrainPositions,
  clearMapDrainPositionsAction,
};
